<template>
  <h1 class="text-petrol-650 px-3 font-normal text-4xl md:text-6xl">
    <slot />
  </h1>
</template>
<script lang="ts" setup></script>
